// utils/drawHelpers.js

// data: your drawingTns
// colIndex: 0 = Quảng Nam, 1 = Đắc Lắc, 2 = Quảng Ngãi
// searchText: substring to match, e.g. "?" or "34" or "316091"
export function getIndexByIncludeText(data, colIndex, searchText) {
    const results = data.results ?? [];

    for (let prizeIndex = 0; prizeIndex < results.length; prizeIndex++) {
        const row = results[prizeIndex];
        // KP shape: row.items[colIndex]; Leap shape: a flat array (single column); SC shape: row.number string
        let colItems = [];
        if (row?.items) {
            colItems = row.items?.[colIndex] ?? [];
        } else if (Array.isArray(row) && colIndex === 0) {
            colItems = row;
        } else if (typeof row?.number === "string" && colIndex === 0) {
            colItems = [row.number];
        }

        for (let itemIndex = 0; itemIndex < colItems.length; itemIndex++) {
            const val = colItems[itemIndex];

            if (typeof val === "string" && val.includes(searchText)) {
                return {
                    index: [prizeIndex, colIndex, itemIndex],
                    value: val
                };
            }
        }
    }

    return null; // no match found
}

export function getIndexByIncludeTextAllCols(data, searchText) {
    const results = data.results ?? [];

    for (let prizeIndex = 0; prizeIndex < results.length; prizeIndex++) {
        const row = results[prizeIndex];
        // KP shape: multiple columns under items; Leap shape: a flat array
        if (row?.items) {
            for (let colIndex = 0; colIndex < row.items.length; colIndex++) {
                const colItems = row.items?.[colIndex] ?? [];

                for (let itemIndex = 0; itemIndex < colItems.length; itemIndex++) {
                    const val = colItems[itemIndex];

                    if (typeof val === "string" && val.includes(searchText)) {
                        return {
                            index: [prizeIndex, colIndex, itemIndex], // [x,y,z]
                            value: val
                        };
                    }
                }
            }
        } else if (Array.isArray(row)) {
            for (let itemIndex = 0; itemIndex < row.length; itemIndex++) {
                const val = row[itemIndex];

                if (typeof val === "string" && val.includes(searchText)) {
                    return {
                        index: [prizeIndex, 0, itemIndex],
                        value: val
                    };
                }
            }
        } else if (typeof row?.number === "string") {
            const val = row.number;
            if (val.includes(searchText)) {
                return {
                    index: [prizeIndex, 0, 0],
                    value: val
                };
            }
        }
    }

    return null; // no match found
}


// Optional: get value back from an index triple
export function getValueByIndex(data, [prizeIndex, colIndex, itemIndex]) {
    if (!data || !data.results) return null;
    const row = data.results?.[prizeIndex];
    if (row?.items) {
        return row.items?.[colIndex]?.[itemIndex] ?? null;
    }
    if (Array.isArray(row) && colIndex === 0) {
        return row[itemIndex] ?? null;
    }
    if (typeof row?.number === "string" && colIndex === 0 && itemIndex === 0) {
        return row.number;
    }
    return null;
}

// Optional: how many columns to render (3 or 4 etc.)
export function getColumnCount(data) {
    const firstRow = data.results?.[0];
    return data.header?.length
        ?? firstRow?.items?.length
        ?? (Array.isArray(firstRow) ? 1 : 0);
}

export function setValueByIndex(results, [x, y, z], newValue) {
    return [
        ...results.map((row, i) =>
            i !== x
                ? row
                : row?.items
                    ? {
                        ...row,
                        items: row.items.map((col, j) =>
                            j !== y
                                ? col
                                : col.map((v, k) => (k === z ? newValue : v))
                        )
                    }
                    : typeof row?.number === "string" && y === 0 && z === 0
                        ? { ...row, number: newValue }
                        : row
        )
    ]
}
